import { FormField } from "@/components/elements/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Input } from "@/components/elements/Input";
import { ZIP_CODE_DEBOUNCE_DELAY } from "@/constants/common";
import { TEmployeeApplicationForm } from "@/features/renew-visa/types/employeeApplicationForm";
import { useZipCodeHandler } from "@/hooks/useZipCodeHandler";
import { Grid } from "@mui/material";
import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { useDebouncedCallback } from "use-debounce";

type TEmployeeIntermediaryFormProps = {
  readonly: boolean;
  messageInvalidZipCodeRef: React.MutableRefObject<string | null | undefined>;
};

export const EmployeeIntermediaryForm: FC<TEmployeeIntermediaryFormProps> = ({ readonly, messageInvalidZipCodeRef }) => {
  const methods = useFormContext<TEmployeeApplicationForm>();
  const { control } = methods;

  const { handleZipCodeChange } = useZipCodeHandler<TEmployeeApplicationForm>({
    names: {
      zipCode: "intermediaryZipCode",
      province: "intermediaryProvince",
      municipality: "intermediaryMunicipality",
      address: "intermediaryAddress",
    },
    methods,
  });

  const handleChangeZipCode = useDebouncedCallback(async (value: string) => {
    const promise = await handleZipCodeChange(value);
    messageInvalidZipCodeRef.current = promise;
    setTimeout(async () => {
      await methods.trigger("intermediaryZipCode");
    }, 0);
  }, ZIP_CODE_DEBOUNCE_DELAY);

  return (
    <InnerBox title="取次者" bordered p={3} required>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <FormField control={control} name="employeeInfoTwoRasImmiFullName">
            <Input readonly={readonly} />
          </FormField>
        </Grid>
        <Grid item xs={6} />
        <Grid item xs={6}>
          <FormField id="employeeInfoTwoRasImmiAffiliatedInstitution" control={control} name="intermediaryName">
            <Input transformToHalfWidth readonly={readonly} />
          </FormField>
        </Grid>
        <Grid item xs={6} />
        <Grid item xs={6}>
          <FormField control={control} name="intermediaryZipCode">
            <Input readonly={readonly} onChange={(e) => handleChangeZipCode(e.target.value)} />
          </FormField>
        </Grid>
        <Grid item xs={6} />
        <Grid item xs={6}>
          <FormField control={control} name="intermediaryProvince">
            <Input readonly />
          </FormField>
        </Grid>
        <Grid item xs={6}>
          <FormField control={control} name="intermediaryMunicipality">
            <Input readonly />
          </FormField>
        </Grid>
        <Grid item xs={12}>
          <FormField control={control} name="intermediaryAddress">
            <Input transformToFullWidth readonly={readonly} />
          </FormField>
        </Grid>
        <Grid item xs={6}>
          <FormField id="employeeInfoTwoRasImmiTelNumber" control={control} name="intermediaryTelNumber">
            <Input transformToHalfWidth readonly={readonly} />
          </FormField>
        </Grid>
      </Grid>
    </InnerBox>
  );
};
